import { useActiveOrganizationMembers } from '@/Pages/Settings/utils/useMembers';

export const useGetLSUserIdFromUser = (userId?: string) => {
  const { data: members, isLoading: membersLoading } =
    useActiveOrganizationMembers(
      userId
        ? {
            user_ids: [userId],
            offset: 0,
            limit: 1,
          }
        : null,
      {
        revalidateOnFocus: false,
      }
    );

  const member = members?.[0];
  const { linked_login_methods, ls_user_id } = member ?? {};
  if (ls_user_id) {
    return {
      lsUserId: ls_user_id,
      isLoading: membersLoading,
    };
  }
  // not sure that this will ever happen
  const { ls_user_id: fallBackLSUserId } = linked_login_methods?.[0] ?? {};
  return {
    lsUserId: fallBackLSUserId,
    isLoading: membersLoading,
  };
};
